<template>
  <div :style="height ? { height } : null" :class="{'pf23-inFo-blank02': displayRight}">
    <label
      class="fntP pf23-inFo-file"
      :class="isLeft ? 'pf23-inFo-L' : 'pf23-inFo-R'"
      :style="isLeft && hideBtn ? { display: 'block' } : null"
    >
      <em
        class="disIb"
        :class="{
          moOnly: !isLeft,
          padBS: isLeft && hideBtn
        }"
      >{{ question.title }} <span v-if="question.required === 'TRUE'" class="ico-must-astar"></span></em>
      <slot name="inner"></slot>
      <span
        class="pf23-fileBtn"
        :class="{ disabled: disabled || existFileData }"
        :style="[
          hideBtn ? { display: 'none' } : null,
          disabled || existFileData ? null : { cursor: 'pointer' }
        ]"
        @click="clickUploadButton"
      >파일 업로드</span>
    </label>
    <input
      v-if="!existFileData"
      type="file"
      ref="attachment"
      accept=".heic, .heif, .png, .jpg, .pdf"
      style="display:none;"
      :name="`file${resIdx}_${question.sq_code}`"
      @change="uploadAttachment"
    >
    <div class="posRe" :style="hideBtn ? { display: 'none' } : null">
      <label
        class="pf23-inFo-file marTS pf23-fileInput"
        @click="downloadFile"
      >
        <input
          type="text"
          class="file_download"
          :title="originalName"
          :value="originalName"
          :style="existFileData ? { cursor: 'pointer' } : null"
          readonly
        />
        <button
          class="posAb"
          @click="deleteAttachment"
          style="right:0; top:6px; background:none;"
          :style="!existFileData || disabled ? { display: 'none' } : null"
        >
          <img src="../images/btn_close.png" alt="파일 삭제 버튼" />
        </button>
      </label>
    </div>
    <slot name="outer"></slot>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { SURVEY_SYDNEY, SET_COMMON_DATA, COMMON_QUESTIONS } from '@/store/actions/survey'
import { AttachmentMixin } from '../mixins'

export default {
  name: 'SurveyAttachmentCommon',
  mixins: [AttachmentMixin],
  props: {
    participant: {
      type: Object,
      default: () => ({})
    },
    isLeft: {
      type: Boolean,
      default: true,
    },
    hideBtn: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: null,
    },
    displayRight: { 
      type: Boolean,
      default: null,
    },
  },
  computed: {
    ...mapState(SURVEY_SYDNEY, {
      commonData: state => state.commonData,
    }),
    ...mapGetters(SURVEY_SYDNEY, {
      questions: COMMON_QUESTIONS
    }),
    s3FilePath() {
      return `survey/${this.sCode}/${this.waveNumber}/${this.aboUid}/common`;
    },
    fileData() {
      return this.commonData[this.sqCode];
    },
  },
  methods: {
    setFileData(path, originalName) {
      this.$store.commit(`${SURVEY_SYDNEY}/${SET_COMMON_DATA}`, {
        sq_code: this.sqCode,
        path,
        original_name: originalName,
        hasError: !path || !originalName
      });
    },
    resetFileData() {
      this.$store.commit(`${SURVEY_SYDNEY}/${SET_COMMON_DATA}`, {
        sq_code: this.sqCode,
        original_name: null,
        path: null,
        hasError: false
      });
    }
  },
}
</script>

<style scoped>
input.file_download {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>


// WEBPACK FOOTER //
// src/views/surveys/sydney/components/SurveyAttachmentCommon.vue